import { render, staticRenderFns } from "./acompanhamento.vue?vue&type=template&id=6b384861&scoped=true"
import script from "./acompanhamento.vue?vue&type=script&lang=js"
export * from "./acompanhamento.vue?vue&type=script&lang=js"
import style0 from "./acompanhamento.vue?vue&type=style&index=0&id=6b384861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b384861",
  null
  
)

export default component.exports